module.exports = __webpack_public_path__ + "static/media/talkingfoot.daf69627.gif";